export type InternetProspectResponse = {
  ApplicationReferenceNumber: number
  IsSuccessful: boolean
}

export type DuplicateAccountAndInternetProspectResponse = InternetProspectResponse & {
  DuplicateExists: boolean
}

export type VerificationResponse = {
  CaptchaFail: boolean
  EnquiryId: string
  AddressVerified: boolean
  NameVerified: boolean
  DateOfBirthVerified: boolean
  RwwaRanking: string
  IsSuccessful: boolean
}

export type AccountSignUp = {
  ApplicationReferenceNumber?: number
  FirstName: string
  MiddleName?: string
  Surname: string
  DateOfBirth: string
  Email?: string
  MobileNumber?: string
  IsReceiveSpecialOffers?: boolean
  HomeNumber?: string
  PreferredMobile?: boolean
  EmailAddressError?: string
  MobileError?: string

  IsInternational?: boolean
  ResidentialAddress?: Address
  PreviousAddress?: Address

  AffiliateId?: string
  LocationId?: string
  VenueId?: string
  OpeningLocation?: string
  InteractiveSignup: boolean
  TicketTransactions?: boolean

  ElectronicIdEnquiryId?: string
  ElectronicIdLastScore?: number
  Status?: string
  FailedReason?: string

  AgeVerification?: AgeVerification

  Password?: string
  ConfirmPassword?: string

  MarketingOptIn?: boolean

  UserAgentString?: string
  RequestMetaData?: RequestMetaData
  GPSVenue?: string
  GPSLocation?: string
}

export type RequestMetaData = {
  IPAddress: object
}

export type Address = {
  UnitNumber?: string
  StreetNumber?: string
  StreetName?: string
  StreetType?: string
  SuburbStatePostCode?: string
  Suburb?: string
  State?: string
  PostCode?: string
  Country?: string
  Moniker?: string
  ProviderLookup?: boolean
}

export type AgeVerification = {
  DriversLicense?: DriversLicense
  Medicare?: Medicare
  Passport?: Passport
  None: boolean
  Attempt: number
  EnquiryId: string
}

export type DriversLicense = {
  State: string
  LicenseNumber: string
  CardNumber: string
  Expiry: string
  Challenge: string
  Response: string
}

export enum MedicareCardColor {
  Yellow,
  Green,
  Blue,
}

export type Medicare = {
  CardNumber: string
  ReferenceNumber: string

  ExpiryDay?: number
  ExpiryMonth?: number
  ExpiryYear?: number

  MiddleName: string
  Color: MedicareCardColor
}

export type Passport = {
  Country: string
  PassportNumber: string
  BirthSurname: string
  PlaceOfBirth: string
  CountryOfBirth: string
  CitizenshipSurname: string
  CitizenshipGivenName: string
}
